import styled from 'styled-components';
import { InboxOutlined } from '@ant-design/icons';
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon';
import { BREAKPOINTS_NUM } from 'constants/Global/Breakpoints.const';

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: #f5f5f5;

  @media (max-width: ${BREAKPOINTS_NUM.tabletMini - 1}) {
    padding: 0 8px 8px;
  }
`;

export const EmptyListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
  padding: 5% 0;
  align-items: center;

  background-color: #fbfcfe;
`;

export const EmptyIconContainer = styled.div`
  padding: 8px;
  background-color: #f5f5f5;
`;

export const EmptyIcon = styled(InboxOutlined)<AntdIconProps>`
  color: #8c8c8c;
  font-size: 3rem;
`;

export const EmptyTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const EmptyTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 700;
  color: #262626;

  margin-bottom: 0px;
`;

export const EmptySubtitle = styled.h3`
  font-size: 0.875rem;
  font-weight: 400;
  color: #8c8c8c;
`;
